// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__AkVia","navbarItem":"Navbar_navbarItem__dulGe","navbarItemActive":"Navbar_navbarItemActive__z+skZ"};